import { cn } from '@/utils/cn';

interface PillSelectorProps {
  options: readonly string[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
  proOptions?: string[]; // Options that require Pro
  disabledOptions?: string[]; // Options that are disabled/locked
  isPro?: boolean;
  onProClick?: () => void;
}

export function PillSelector({
  options,
  value,
  onChange,
  label,
  proOptions = [],
  disabledOptions = [],
  isPro = false,
  onProClick,
}: PillSelectorProps) {
  const handleClick = (option: string) => {
    // Check if option is disabled
    if (disabledOptions.includes(option)) {
      return;
    }
    const isProOption = proOptions.includes(option);
    if (isProOption && !isPro) {
      onProClick?.();
      return;
    }
    onChange(option);
  };

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-text-secondary mb-3">
          {label}
        </label>
      )}
      <div className="flex flex-wrap gap-3">
        {options.map((option) => {
          const isSelected = value === option;
          const isProOption = proOptions.includes(option);
          const isDisabled = disabledOptions.includes(option);
          const isLocked = (isProOption && !isPro) || isDisabled;
          
          return (
            <button
              key={option}
              type="button"
              onClick={() => handleClick(option)}
              disabled={isDisabled}
              className={cn(
                'relative px-5 py-2.5 rounded-full border transition-all text-base font-medium min-w-[70px]',
                isSelected
                  ? 'border-primary bg-primary/10 text-primary'
                  : isLocked
                    ? 'border-glass-border bg-surface-light/50 text-text-tertiary cursor-not-allowed'
                    : 'border-glass-border hover:border-primary/30 text-text-secondary hover:text-text-primary'
              )}
            >
              {option}
              {isProOption && (
                <span className="absolute -top-1.5 -right-1.5 px-1.5 py-0.5 text-[10px] font-bold bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded">
                  PRO
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

